import { observable, action, runInAction } from 'mobx';
import { cloneDeep, isEmpty } from 'lodash';

import HRService from '@service/hr';
import { initCityList } from './store';
import moIndex from '../../store/index';

const moCityStore = observable({
  list: <any[]>[],
  activeList: <any[]>[],
  isModal: false,
});

const updateFreshList = action(async () => {
  const { freshCategoryYear } = moIndex;
  let result: any = await HRService.cityFreshCategory(freshCategoryYear);
  initCityList(result);
});

const initActiveList = action(async () => {
  const arr: any[] = cloneDeep(moCityStore.list);
  const newArr: any[] = [];
  let activeArr: any[] = [];
  const result: any = await HRService.getUserOption();
  // console.log('result -- ', result);
  arr.map((item: any) => {
    result?.multi_cities_fresh_graduate?.map((child: any) => {
      if (item.name === child) item.active = true;
    });
  });

  const res: any = await HRService.freshCityOption();

  arr?.map((item: any) => {
    if (res?.includes(item.name)) newArr.push(item);
  });

  newArr.map((item: any) => {
    if (item.active) activeArr.push(item.name);
  });

  // console.log('应届生起薪 城市 -- ', newArr);
  runInAction(() => {
    moCityStore.list = newArr;
    moCityStore.activeList = activeArr;
  });
});;

const freshCityInit = action((res: any) => {
  if (isEmpty(res)) return;

  let list: any[] = [];
  let activeList: any[] = [];

  res.map((item: any) => {
    if (!item.is_area_type && !item.is_city_type && (item.city_type !== '全国')) {
      list.push({
        code: item.code,
        name: item.name,
        active: false,
        hover: false,
      });
    }
  });

  moCityStore.list = list;
  moCityStore.activeList = [];
  initActiveList();
});

const chooseCity = action(async (code: number | string) => {
  const arr: any[] = cloneDeep(moCityStore.list);
  let activeArr: any[] = [];
  arr.map((item: any) => {
    if (item.code === code) item.active = true;
  });
  arr.map((item: any) => {
    if (item.active) activeArr.push(item.name);
  });
  const res: any = await HRService.editUserOption({
    multi_cities_fresh_graduate: activeArr,
  });
  if (res.code !== 0) return;
  runInAction(() => {
    moCityStore.list = arr;
    moCityStore.activeList = activeArr;

    updateFreshList();
  });
});

const unChooseCity = action(async (code: number | string) => {
  const arr: any[] = cloneDeep(moCityStore.list);
  let activeArr: any[] = [];
  arr.map((item: any) => {
    if (item.code === code) item.active = false;
  });
  arr.map((item: any) => {
    if (item.active) activeArr.push(item.name);
  });
  const res: any = await HRService.editUserOption({
    multi_cities_fresh_graduate: activeArr,
  });
  if (res.code !== 0) return;
  runInAction(() => {
    moCityStore.list = arr;
    moCityStore.activeList = activeArr;

    updateFreshList();
  });
});

const changeCity = action((code: number | string, active: boolean) => {
  if (active) unChooseCity(code);
  else chooseCity(code);
});

const toggleModal = action((value: boolean) => {
  moCityStore.isModal = value;
});

export default moCityStore;
export { freshCityInit, toggleModal, changeCity };
